if (!customElements.get('collection-card-variant-picker')) {
  customElements.define('collection-card-variant-picker', class CollectionCardVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.onSwatchClick = this.onSwatchClick.bind(this);
      this.onSwatchEnter = this.onSwatchEnter.bind(this);
      this.onSwatchLeave = this.onSwatchLeave.bind(this);
    }

    connectedCallback() {
      this.cardWrapper = this.closest('.card-wrapper');
      if (!this.cardWrapper) return;

      this.primaryImage = this.cardWrapper.querySelector('[data-card-primary-image]');
      this.productLinks = Array.from(this.cardWrapper.querySelectorAll('[data-card-product-link]'));
      this.quickAddTrigger = this.cardWrapper.querySelector('[data-card-quick-add]');
      this.swatches = Array.from(this.querySelectorAll('[data-collection-card-swatch]'));
      this.selectedSwatch = null;

      if (!this.primaryImage || this.swatches.length < 2) {
        this.remove();
        return;
      }

      this.originalState = {
        image: {
          src: this.primaryImage.getAttribute('src'),
          srcset: this.primaryImage.getAttribute('srcset'),
          alt: this.primaryImage.getAttribute('alt'),
          width: this.primaryImage.getAttribute('width'),
          height: this.primaryImage.getAttribute('height')
        },
        productUrls: this.productLinks.map((link) => link.getAttribute('href')),
        quickAddUrl: this.quickAddTrigger ? this.quickAddTrigger.getAttribute('data-product-url') : null
      };

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseenter', this.onSwatchEnter);
        swatch.addEventListener('mouseleave', this.onSwatchLeave);
      });

      this.preloadVariantImages();
    }

    disconnectedCallback() {
      if (!this.swatches) return;
      this.swatches.forEach((swatch) => {
        swatch.removeEventListener('click', this.onSwatchClick);
        swatch.removeEventListener('mouseenter', this.onSwatchEnter);
        swatch.removeEventListener('mouseleave', this.onSwatchLeave);
      });
    }

    preloadVariantImages() {
      requestIdleCallback(() => {
        this.swatches.forEach((swatch) => {
          const src = swatch.dataset.imageSrc;
          if (src) {
            const img = new Image();
            img.src = src;
          }
        });
      });
    }

    onSwatchEnter(event) {
      this.applyPreview(event.currentTarget);
    }

    onSwatchLeave() {
      if (this.selectedSwatch) {
        this.applyPreview(this.selectedSwatch);
      } else {
        this.resetPreview();
      }
    }

    onSwatchClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const swatch = event.currentTarget;

      if (swatch === this.selectedSwatch) {
        this.selectedSwatch = null;
        this.resetPreview();
        return;
      }

      this.selectedSwatch = swatch;
      this.applyPreview(swatch);
    }

    applyPreview(swatch) {
      this.updateImage(swatch.dataset);
      this.updateProductUrls(swatch.dataset.productUrl);
      this.cardWrapper.classList.add('card-wrapper--variant-preview');
      this.setSelectedSwatch(swatch);
    }

    resetPreview() {
      this.updateImage(this.originalState.image);
      this.updateProductUrls();
      this.cardWrapper.classList.remove('card-wrapper--variant-preview');
      this.setSelectedSwatch();
    }

    updateImage(imageData) {
      this.primaryImage.setAttribute('src', imageData.imageSrc || imageData.src);
      this.primaryImage.setAttribute('srcset', imageData.imageSrcset || imageData.srcset);
      this.primaryImage.setAttribute('alt', imageData.imageAlt || imageData.alt || '');

      if (imageData.imageWidth || imageData.width) {
        this.primaryImage.setAttribute('width', imageData.imageWidth || imageData.width);
      }

      if (imageData.imageHeight || imageData.height) {
        this.primaryImage.setAttribute('height', imageData.imageHeight || imageData.height);
      }
    }

    updateProductUrls(productUrl) {
      if (productUrl) {
        this.productLinks.forEach((link) => link.setAttribute('href', productUrl));

        if (this.quickAddTrigger) {
          this.quickAddTrigger.setAttribute('data-product-url', productUrl);
        }

        return;
      }

      this.productLinks.forEach((link, index) => {
        link.setAttribute('href', this.originalState.productUrls[index]);
      });

      if (!this.quickAddTrigger) return;

      if (this.originalState.quickAddUrl) {
        this.quickAddTrigger.setAttribute('data-product-url', this.originalState.quickAddUrl);
      } else {
        this.quickAddTrigger.removeAttribute('data-product-url');
      }
    }

    setSelectedSwatch(activeSwatch) {
      this.swatches.forEach((swatch) => {
        const isSelected = swatch === activeSwatch;
        swatch.classList.toggle('is-selected', isSelected);
        swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }
  });
}
